import React, { FC, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { WebUx } from './layouts/WebUx';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import SignUp from './pages/SignUp';
import Home from './pages/Home';
import RequestPasswordRest from './pages/RequestPasswordRest';
import Login from './pages/Login';
import RestPassword from './pages/RestPassword';
import { CssBaseline } from '@mui/material';
import QPage from './pages/Qpage';
import NewHome from './pages/NewHome';
import CbaSubjects from './pages/CbaSubjects';
import CbaPapers from './pages/CbaPapers';
import CbaPaper from './pages/CbaPaper';
import CbaExam from './pages/CbaExam';
import CbaResult from './pages/CbaResult';
import CbaReview from './pages/CbaReview';

const ScrollToTop: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  return (
    <div className='App'>
      <CssBaseline />
      <ScrollToTop />
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Routes>
          <Route path='/' element={<NewHome />} />
          <Route path='/home' element={<Home />} />
          <Route path='/login' element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path='/signup' element={<SignUp />} />
          <Route path='/forget-password' element={<RequestPasswordRest />} />
          <Route path='/password-reset' element={<RestPassword />} />
          <Route path='/app' element={<WebUx />} />
          <Route path='/question/:subTitleId' element={<QPage />} />
          <Route path='/cba' element={<CbaSubjects />} />
          <Route path='/cba/subjects/:categoryId' element={<CbaPapers />} />
          <Route path='/cba/papers/:paperId' element={<CbaPaper />} />
          <Route path='/cba/papers/:paperId/sit' element={<CbaExam />} />
          <Route path='/cba/attempts/:attemptId/result' element={<CbaResult />} />
          <Route path='/cba/attempts/:attemptId/review' element={<CbaReview />} />
          {isAuthenticated ? (
            <Route path='*' element={<Navigate to='/' />} />
          ) : (
            <Route path='*' element={<Navigate to='/login' />} />
          )}
        </Routes>
      </QueryParamProvider>
      <p id='text101' style={{ fontSize: '16px', width: 'fit-content', whiteSpace: 'nowrap', overflow: 'auto' }}></p>
    </div>
  );
};
export default App;
